import { getLocalStorageItem, setLocalStorageItem } from '../utils/localstorage';

class BridgeConfig {

  constructor() {
    this.config = {};

    this.restoreConfig();
  }

  getValue = key => this.config[key];

  setValue = (key, val) => {
    this.config[key] = val;

    this.storeConfig();
  };

  storeConfig = () => {
    setLocalStorageItem('bridgeConfig', JSON.stringify(this.config));
  };

  restoreConfig = () => {
    const config = getLocalStorageItem('bridgeConfig');
    if (!config) {
      return;
    }

    this.config = JSON.parse(config);
  };

}

export default new BridgeConfig();
